/**
 * Which effort the composer shows. A chat keeps the effort it was given even
 * on a model that does not offer it, and shows the nearest one that model
 * does — the effort the Worker sends, so the two must agree: nearest by
 * position in `EFFORTS`, and a tie (Medium on a model with only Low and High)
 * goes up.
 */

import { EFFORTS, type Effort } from '@wire';

export const EFFORT_LABELS: Record<Effort, string> = { low: 'Low', medium: 'Medium', high: 'High' };

/** The effort a model offering `offered` runs `wanted` at; null when it
 *  offers no choice. */
export function nearestEffort(wanted: Effort, offered: readonly Effort[]): Effort | null {
  const at = EFFORTS.indexOf(wanted);
  let best: Effort | null = null;
  let bestGap = Infinity;
  // Lowest first, so of two equal gaps the later, higher one wins.
  for (const e of EFFORTS) {
    const gap = Math.abs(EFFORTS.indexOf(e) - at);
    if (offered.includes(e) && gap <= bestGap) {
      best = e;
      bestGap = gap;
    }
  }
  return best;
}

/** A phone's one chip for the model and its effort — "gpt-oss · Medium" — or
 *  the model alone where it offers no choice. */
export function modelEffortLabel(model: string, effort: Effort | null): string {
  return effort ? `${model} · ${EFFORT_LABELS[effort]}` : model;
}
